import { z } from 'zod'

import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from 'constants/auth'

export const passwordRegex =
  /^(?=.*[\p{Ll}])(?=.*[\p{Lu}])(?=.*[\p{Nd}])(?=.*[\W_])[^ ]{6,}$/gu

export const password1 = /[\p{Ll}]+/gu
export const password2 = /[\p{Lu}]+/gu
export const password3 = /[\p{Nd}]+/gu
export const password4 = /[\W|_]/

export const textRegex = /^[\p{L}\- ]+$/gu

const signUpValidator = z
  .object({
    firstName: z.string().regex(textRegex, 'custom.plainText'),
    lastName: z.string().regex(textRegex, 'custom.plainText'),
    email: z.string().email(),
    organisationId: z.string().uuid().optional(),
    password: z
      .string()
      .regex(password1, 'custom.mustContainLowercase')
      .regex(password2, 'custom.mustContainUppercase')
      .regex(password3, 'custom.mustContainNumber')
      .regex(password4, 'custom.mustContainSpecialCharacter')
      .min(MIN_PASSWORD_LENGTH, 'custom.mustContain8Character')
      .max(MAX_PASSWORD_LENGTH, 'custom.mustContain36Character')
      .regex(passwordRegex, 'custom.passwordDoesNotMeetRequirements'),
    passwordConfirm: z.string(),
    isAccept: z.boolean().refine((data) => data, {
      message: 'custom.acceptTerms'
    })
  })
  .refine((data) => data.password === data.passwordConfirm, {
    message: 'custom.passwordDoNotMatch',
    path: ['passwordConfirm']
  })

export type SignUp = z.infer<typeof signUpValidator>

export default signUpValidator
